import { combineEpics } from 'redux-observable';
import fetchCompetitorsEpic from './fetchCompetitors';
import fetchCollectionEpic from './fetchCollection';
import setNewLogoEpic from './setNewLogo';

export const logosEpic = combineEpics(
  fetchCompetitorsEpic,
  fetchCollectionEpic,
  setNewLogoEpic,
);
